// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_tobenamed3 {
  background: var(--ColorPrimary);
  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 10px;
  width: 30%;
}
/***************************************Ecras pequenos (SmartPhones)***************************************/
@media only screen and (max-width: 600px) {
  .card_tobenamed3 {
    width: auto;
  }
}
/***************************************Ecras Grandes (PCs)***************************************/
@media only screen and (min-width: 600px) {
}
`, "",{"version":3,"sources":["webpack://./src/components/toBeNamedCard3/toBeNamedCard3.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;AACA,2GAA2G;AAC3G;EACE;IACE,WAAW;EACb;AACF;AACA,kGAAkG;AAClG;AACA","sourcesContent":[".card_tobenamed3 {\n  background: var(--ColorPrimary);\n  box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  padding: 10px;\n  width: 30%;\n}\n/***************************************Ecras pequenos (SmartPhones)***************************************/\n@media only screen and (max-width: 600px) {\n  .card_tobenamed3 {\n    width: auto;\n  }\n}\n/***************************************Ecras Grandes (PCs)***************************************/\n@media only screen and (min-width: 600px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
